import { render, staticRenderFns } from "./DateFormField.vue?vue&type=template&id=71288a7e&"
import script from "./DateFormField.vue?vue&type=script&lang=js&"
export * from "./DateFormField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports